"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _debug2 = require("./utils/debug");
var _config = _interopRequireDefault(require("./config"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _classPrivateFieldInitSpec(obj, privateMap, value) { _checkPrivateRedeclaration(obj, privateMap); privateMap.set(obj, value); }
function _checkPrivateRedeclaration(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }
function _classPrivateFieldGet(receiver, privateMap) { var descriptor = _classExtractFieldDescriptor(receiver, privateMap, "get"); return _classApplyDescriptorGet(receiver, descriptor); }
function _classExtractFieldDescriptor(receiver, privateMap, action) { if (!privateMap.has(receiver)) { throw new TypeError("attempted to " + action + " private field on non-instance"); } return privateMap.get(receiver); }
function _classApplyDescriptorGet(receiver, descriptor) { if (descriptor.get) { return descriptor.get.call(receiver); } return descriptor.value; }
var _queue = /*#__PURE__*/new WeakMap();
var _cb = /*#__PURE__*/new WeakMap();
var _debug = /*#__PURE__*/new WeakMap();
class Callbacks {
  constructor() {
    var _this = this;
    _classPrivateFieldInitSpec(this, _queue, {
      writable: true,
      value: {}
    });
    _classPrivateFieldInitSpec(this, _cb, {
      writable: true,
      value: {}
    });
    _classPrivateFieldInitSpec(this, _debug, {
      writable: true,
      value: false
    });
    _defineProperty(this, "set", (name, fn, isQueueable) => {
      var _classPrivateFieldGet2;
      this.log('set', {
        name,
        fn,
        isQueueable
      });
      _classPrivateFieldGet(this, _cb)[name] = fn;
      if (fn && isQueueable && (_classPrivateFieldGet2 = _classPrivateFieldGet(this, _queue)) !== null && _classPrivateFieldGet2 !== void 0 && (_classPrivateFieldGet2 = _classPrivateFieldGet2[name]) !== null && _classPrivateFieldGet2 !== void 0 && _classPrivateFieldGet2.length) {
        _classPrivateFieldGet(this, _queue)[name].map(args => fn(args));
      }
      delete _classPrivateFieldGet(this, _queue)[name];
    });
    _defineProperty(this, "unset", name => {
      if (!name) return;
      delete _classPrivateFieldGet(this, _cb)[name];
      delete _classPrivateFieldGet(this, _queue)[name];
    });
    _defineProperty(this, "get", function (name) {
      var queue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      _this.log('get', {
        name,
        cb: _classPrivateFieldGet(_this, _cb)
      });
      if (_classPrivateFieldGet(_this, _cb)[name]) return _classPrivateFieldGet(_this, _cb)[name];
      if (queue) return _this.queue(name);
      return undefined;
    });
    // prettier-ignore
    _defineProperty(this, "queue", name => function () {
      var _ref;
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this.log('queue', {
        name,
        args,
        queue: _classPrivateFieldGet(_this, _queue)
      });
      if (!name) return null;
      if (!_classPrivateFieldGet(_this, _queue)[name]) {
        _classPrivateFieldGet(_this, _queue)[name] = [];
      }
      _classPrivateFieldGet(_this, _queue)[name].push(...args);
      _classPrivateFieldGet(_this, _queue)[name] = _classPrivateFieldGet(_this, _queue)[name].slice((_ref = -1 * _config.default.callbacks.maxQueueSpecific[name]) !== null && _ref !== void 0 ? _ref : _config.default.callbacks.maxQueueGeneric);
      return null;
    });
    _defineProperty(this, "isExist", name => !!_classPrivateFieldGet(this, _cb)[name]);
    _defineProperty(this, "log", function () {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      if (_classPrivateFieldGet(_this, _debug)) return console.log('debug:callbacks -- ', JSON.stringify(args));
    });
  }
}
var _default = exports.default = (0, _debug2.addDebugAttribute)(new Callbacks(), 'Callbacks');
module.exports = exports.default;